export const NAMESPACE = 'KanBo/Home/settings/'
export const SET = NAMESPACE + 'SET'

const initialState = {
  allowRemoveBoard: true,
  lang: 'en-US',
  officeAppLauncher: false,
  siteType: 'STS#0',
  boardTemplateId: null,
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case SET:
      return {
        ...state,
        ...action.payload
      }
    default: return state
  }
}

export function set (payload) {
  return {
    type: SET,
    payload
  }
}
